import React from "react"
import { Button } from "../Button"
import {
  ptmApplyCtaLabel,
  PTM_APPLICATION_TYPES,
} from "../../utils/prospect/ptmApplicationStatus"

/**
 * Become / Resume / Reapply Associate and Affiliate CTAs from
 * buildReapplyPathOffer action state. Consumers supply click handlers
 * (e.g. confirmation modal vs immediate redirect). `reapplyAssociate` and
 * `reapplyAffiliate` label that path's non-resume button "Reapply" for people
 * who already held that membership; the other path keeps "Become".
 */
const ReapplyPathOfferApplyActions = ({
  associateAction,
  affiliateAction,
  onBecomeAssociate,
  onBecomeAffiliate,
  className = "m-2",
  reapplyAssociate = false,
  reapplyAffiliate = false,
}) => {
  const showAssociate = Boolean(associateAction?.showApplyCta)
  const showAffiliate = Boolean(affiliateAction?.showApplyCta)

  if (!showAssociate && !showAffiliate) {
    return null
  }

  return (
    <>
      {showAssociate ? (
        <Button
          color="primary"
          className={className}
          onClick={onBecomeAssociate}
        >
          {ptmApplyCtaLabel({
            applicationType: PTM_APPLICATION_TYPES.ASSOCIATE,
            isResume: associateAction?.isResume,
            isClosedRegistration: associateAction?.isClosedRegistration,
            isReapply: reapplyAssociate,
          })}
        </Button>
      ) : null}
      {showAffiliate ? (
        <Button
          color="primary"
          className={className}
          onClick={onBecomeAffiliate}
        >
          {ptmApplyCtaLabel({
            applicationType: PTM_APPLICATION_TYPES.AFFILIATE,
            isResume: affiliateAction?.isResume,
            isClosedRegistration: affiliateAction?.isClosedRegistration,
            isReapply: reapplyAffiliate,
          })}
        </Button>
      ) : null}
    </>
  )
}

export default ReapplyPathOfferApplyActions
